<template>
  <div class="modal stackLoading full">
    <div class="container">
      <div class="loading-wrap">
        <!--<img src="./image/load.gif" alt="">-->
      </div>
    </div>
  </div>
</template>

<script>
  import NativeApi from '@/utils/nativeApi'
  let napiCient = window.napiCient = new NativeApi();
    export default {
        name: "paid",
        mounted(){
          document.title = "支付结果";
            console.log('paid loaded__________________________')
            console.log('href' , location.href)
            this.showLoading();
            
            let pays = location.href.split('?')[1].split('&')[0].split('=')[1];
            let user = location.href.split('?')[1].split('&')[1].split('=')[1];
            let opts = {
              "pays": parseInt(pays),
              "user": parseInt(user)
            };

          napiCient.run('notifyGalleryDidPayServiceSuccess',[opts]);
          }
    }
</script>

<style scoped>

</style>
